/**
 * FAQ accordion: measure inner content height because overflow:hidden + max-height:0
 * makes the answer's own scrollHeight 0.
 */
(function () {
    'use strict';

    function answerHeight(item) {
        const content = item.querySelector('.faq__answer-content');
        if (!content) {
            return 0;
        }
        return content.scrollHeight;
    }

    function setExpanded(item, expanded) {
        const question = item.querySelector('.faq__question');
        const answer = item.querySelector('.faq__answer');
        if (!question || !answer) {
            return;
        }

        item.classList.toggle('is-active', expanded);
        question.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        answer.setAttribute('aria-hidden', expanded ? 'false' : 'true');

        if (expanded) {
            answer.style.maxHeight = answerHeight(item) + 'px';
        } else {
            answer.style.maxHeight = '0px';
        }
    }

    function initFaq(root) {
        const items = Array.from((root || document).querySelectorAll('.faq__item'));
        if (!items.length) {
            return;
        }

        items.forEach(function (item, index) {
            if (item.dataset.faqReady === '1') {
                return;
            }
            item.dataset.faqReady = '1';

            const question = item.querySelector('.faq__question');
            const answer = item.querySelector('.faq__answer');
            if (!question || !answer) {
                return;
            }

            const answerId = answer.id || 'faq-answer-' + index + '-' + Math.random().toString(36).slice(2, 8);
            answer.id = answerId;
            question.setAttribute('aria-controls', answerId);
            if (!question.getAttribute('id')) {
                question.setAttribute('id', answerId + '-question');
            }

            setExpanded(item, item.classList.contains('is-active'));

            question.addEventListener('click', function () {
                const willOpen = !item.classList.contains('is-active');
                items.forEach(function (other) {
                    if (other !== item) {
                        setExpanded(other, false);
                    }
                });
                setExpanded(item, willOpen);
                window.requestAnimationFrame(function () {
                    if (item.classList.contains('is-active')) {
                        const answer = item.querySelector('.faq__answer');
                        if (answer) {
                            answer.style.maxHeight = answerHeight(item) + 'px';
                        }
                    }
                });
            });
        });
    }

    function initAll() {
        if (window.__bpThemeFaqBound) {
            document.querySelectorAll('.faq__item.is-active').forEach(function (item) {
                const answer = item.querySelector('.faq__answer');
                if (answer) {
                    answer.style.maxHeight = answerHeight(item) + 'px';
                }
            });
            return;
        }
        window.__bpThemeFaqBound = true;
        document.querySelectorAll('.faq').forEach(function (block) {
            initFaq(block);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll);
    } else {
        initAll();
    }

    window.addEventListener('resize', function () {
        document.querySelectorAll('.faq__item.is-active').forEach(function (item) {
            const answer = item.querySelector('.faq__answer');
            if (answer) {
                answer.style.maxHeight = answerHeight(item) + 'px';
            }
        });
    });

    if (typeof acf !== 'undefined' && typeof acf.addAction === 'function') {
        acf.addAction('render_block_preview/type=faq', initAll);
    }
})();
